import React from "react";

export default function Two() {
  return (
    <div className="die-face second-face">
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  );
}
